export enum JsonSchemaId {
  CreateReport = 'createReport',
  EditReport = 'editReport'
}
